var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRoundArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "rotate(90 20 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 18.5,
    stroke: "#0F0",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0F0",
    fillRule: "nonzero",
    d: "M19.086 13.086l-7.707 7.707 1.414 1.414 6-6v10.586c0 .553 2 .553 2 0V16.207l6 6 1.414-1.414-7.707-7.707a.999.999 0 00-1.414 0z"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0MCA0MCI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiB0cmFuc2Zvcm09InJvdGF0ZSg5MCAyMCAyMCkiPjxjaXJjbGUgY3g9IjIwIiBjeT0iMjAiIHI9IjE4LjUiIHN0cm9rZT0iIzBGMCIgc3Ryb2tlLXdpZHRoPSIzIi8+PHBhdGggZmlsbD0iIzBGMCIgZmlsbC1ydWxlPSJub256ZXJvIiBkPSJtMTkuMDg2IDEzLjA4Ni03LjcwNyA3LjcwNyAxLjQxNCAxLjQxNCA2LTZ2MTAuNTg2YzAgLjU1MyAyIC41NTMgMiAwVjE2LjIwN2w2IDYgMS40MTQtMS40MTQtNy43MDctNy43MDdhLjk5OS45OTkgMCAwIDAtMS40MTQgMFoiLz48L2c+PC9zdmc+";
export { SvgRoundArrow as ReactComponent };